// extracted by mini-css-extract-plugin
module.exports = {"codeEditorSubheader":"CodeEditorSubheader_codeEditorSubheader__1GHS5","templateName":"CodeEditorSubheader_templateName__2HkK1"};